
import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  computed: {
    ...mapState("assets", {
      oss: "oss"
    }),
    ...mapState("app", {
      isCN: "isCN",
      isMobile: "isMobile"
    })
  }
});
